// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   Paper,
//   DialogContent,
//   MenuItem,
//   TablePagination,
// } from '@mui/material';
// import {
//   BootstrapDialog,
//   BootstrapDialogTitle,
//   Breadcrumb,
//   CTSinput,
//   CTSRinput,
//   StyledTableCell,
//   StyledTableRow,
// } from '../../reusableComponent/Reusables';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useForm, Controller } from 'react-hook-form';
// import { Print } from '@mui/icons-material';
// import styles from '../../../styles.module.css';
// import dayjs from 'dayjs';
// import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// import empty_delivery_challan from '../../../services/empty_delivery_challan';
// import depotMasterService from '../../../services/masters/depotMaster.Service';
// import { useSelector } from 'react-redux';

// const printStyles = `
//   @media print {
//     body * {
//       visibility: hidden;
//     }
//     .printable-area, .printable-area * {
//       visibility: visible;
//     }
//     .printable-area {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 100%;
//       padding: 10px;
//       background: none !important;
//     }
//     .no-print {
//       display: none !important;
//     }
//     .printable-table {
//       width: 100%;
//       table-layout: auto;
//       font-size: 10px;
//       overflow: hidden !important; /* Prevent scrolling */
//       background: none !important;
//       border-collapse: collapse;
//     }
//     .printable-table th, .printable-table td {
//       padding: 6px;
//       white-space: normal;
//       word-wrap: break-word;
//       font-size: 12px !important;
//       text-align: left;
     
//       border-bottom: 1px solid #000 !important;
//     }
//     .printable-table th {
//       font-weight: bold;
//     }
//     .print-header {
//       text-align: left !important;
//       font-size:20px;
//       font-weight: bold;
//       margin-bottom: 15px;
//     }
//     .print-filters {
//       display: flex;
//       justify-content: flex-start;
//       margin-bottom: 15px;
//       font-size: 14px;
//     }
//     .print-filters span {
//       margin-right: 20px;
//     }
//     .MuiPaper-root {
//       background: none !important;
//       box-shadow: none !important;
//     }
//     .list-tbl-container {
//       overflow: hidden !important; /* Remove scrollbars */
//       max-width: 100%;
//     }
//   }
// `;

// const EmptyChallanReports = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state || null;

//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const depot_id = userInfo.depot_id;
//   const plant_id = userInfo.plant_id;

//   const [successMessage, setSuccessMessage] = useState('');
//   const [displayData, setDisplayData] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [info, setInfo] = useState([]);
//   const [openDetail, setDetail] = useState(false);
//   const defaultRowsPerPage = useSelector(state => state.delivery_challan.rows_per_page || 15);

//   const {
//     control,
//     watch,
//     formState: { errors },
//     setError,
//   } = useForm({
//     defaultValues: {
//       entry_date_from: editData?.entry_date ? dayjs(editData.entry_date).format('YYYY-MM-DD') : '',
//       entry_date_to: '',
//       depot: '',
//     },
//   });

//   const entryDateFrom = watch('entry_date_from');
//   const entryDateTo = watch('entry_date_to');
//   const selectedDepot = watch('depot');

//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: defaultRowsPerPage,
//   });

//   const sortedRows = [...displayData].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
//   const [total_count, setTotalCount] = useState(0);
//   const effectiveTotalCount = total_count > 0 ? total_count : displayData.length;
//   const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
//   const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
//   const paginationInfo = `${startRecord}-${endRecord} of ${effectiveTotalCount}`;

//   useEffect(() => {
//     setController(prev => ({
//       ...prev,
//       rowsPerPage: defaultRowsPerPage,
//       page: 0,
//     }));
//   }, [defaultRowsPerPage]);

//   useEffect(() => {
//     async function fetchDepotData() {
//       try {
//         setLoading(true);
//         const depotData = await depotMasterService.getDepotList({
//           page: 0,
//           size: 999,
//           searchKey: '',
//         });
//         setDepot(depotData || []);
//       } catch (error) {
//         console.error('Error fetching depot data:', error);
//         setSuccessMessage('Error fetching depot data');
//         setDepot([]);
//       } finally {
//         setLoading(false);
//       }
//     }
//     fetchDepotData();

//     const styleSheet = document.createElement('style');
//     styleSheet.type = 'text/css';
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);

//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   const handleShow = useCallback(async (formData) => {
//     const { entry_date_from, entry_date_to, depot } = formData;

//     if (!entry_date_from) {
//       setError('entry_date_from', { message: 'From Date is required' });
//       return;
//     }

//     if (!entry_date_to) {
//       setError('entry_date_to', { message: 'To Date is required' });
//       return;
//     }

//     if (!depot) {
//       setError('depot', { message: 'Depot is required' });
//       return;
//     }

//     if (dayjs(entry_date_to).isBefore(dayjs(entry_date_from))) {
//       setError('entry_date_to', { message: 'To Date cannot be before From Date' });
//       return;
//     }

//     try {
//       setLoading(true);
//       setDisplayData([]);

//       const filterParams = {
//         page: 0,
//         size: 999,
//         searchKey: '',
//         fromDate: entry_date_from,
//         toDate: entry_date_to,
//         from_depot_name: depot === 'all' ? '' : depot,
//       };

//       const response = await empty_delivery_challan.getEmptyChallanReport(filterParams);
//       let fetchedData = response?.data || response || [];

//       if (depot !== 'all') {
//         fetchedData = fetchedData.filter(row => row.from_depot_name === depot);
//       }

//       setDisplayData(fetchedData);
//       setTotalCount(response?.totalCount || fetchedData.length);

//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setSuccessMessage(error.message || 'Error fetching data');
//       setDisplayData([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [setError]);

//   useEffect(() => {
//     if (entryDateFrom && entryDateTo && selectedDepot && !errors.entry_date_from && !errors.entry_date_to && !errors.depot) {
//       handleShow({
//         entry_date_from: entryDateFrom,
//         entry_date_to: entryDateTo,
//         depot: selectedDepot,
//       });
//     }
//   }, [entryDateFrom, entryDateTo, selectedDepot, errors, handleShow]);

//   const handlePrint = () => {
//     window.print();
//   };

//   const handleDetails = (tableData) => {
//     const parsedData = JSON.parse(tableData);
//     setInfo(parsedData);
//     setDetail(true);
//   };

//   const handleClose = () => {
//     setDetail(false);
//   };

//   const dateConversion = (date) => {
//     if (!date) return '';
//     const today = new Date(date);
//     const dd = String(today.getDate()).padStart(2, '0');
//     const mm = String(today.getMonth() + 1).padStart(2, '0');
//     const yyyy = today.getFullYear();
//     return `${dd}/${mm}/${yyyy}`;
//   };

//   const getDepotName = (depot_name) => {
//     const depotData = depot.find((d) => d.depot_name === depot_name);
//     return depotData?.depot_name || depot_name || 'Unknown';
//   };

//   const handleChangePage = (event, newPage) => {
//     setController({
//       ...controller,
//       page: newPage,
//     });
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       ...controller,
//       rowsPerPage: parseInt(event.target.value, 10),
//       page: 0,
//     });
//   };

//   return (
//     <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: 'Empty Challan Report' }]} />
//         <Typography className={styles.header_txt}>EMPTY CHALLAN REPORT</Typography>

//         <form className="no-print">
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>From Date</Typography>
//                 <Controller
//                   name="entry_date_from"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       size="small"
//                       fullWidth
//                       type="date"
//                       {...field}
//                       error={!!errors.entry_date_from}
//                       helperText={errors.entry_date_from?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>To Date</Typography>
//                 <Controller
//                   name="entry_date_to"
//                   control={control}
//                   render={({ field }) => (
//                     <CTSRinput
//                       size="small"
//                       fullWidth
//                       type="date"
//                       {...field}
//                       error={!!errors.entry_date_to}
//                       helperText={errors.entry_date_to?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography className={styles.label_Txt_add}>Depot</Typography>
//                 <Controller
//                   name="depot"
//                   control={control}
//                   rules={{ required: 'Depot is required' }}
//                   render={({ field }) => (
//                     <CTSRinput
//                       select
//                       size="small"
//                       fullWidth
//                       {...field}
//                       error={!!errors.depot}
//                       helperText={errors.depot?.message}
//                       InputProps={{ className: styles.CTSinput_Box }}
//                     >
//                       <MenuItem value="">Select Depot</MenuItem>
//                       <MenuItem value="all">All Depots</MenuItem>
//                       {depot.map((depotItem) => (
//                         <MenuItem key={depotItem.depot_id} value={depotItem.depot_name}>
//                           {depotItem.depot_name}
//                         </MenuItem>
//                       ))}
//                     </CTSRinput>
//                   )}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </form>

//         <Grid item xs={12} sx={{ mt: 4 }}>
//           <Paper sx={{ width: '100%' }} className="printable-area">
//             <Box sx={{ display: 'none', displayPrint: 'block', textAlign: 'left' }}>
//               <Typography variant="h3" className="print-header">
//                 EMPTY CHALLAN REPORT
//               </Typography>
//               <Box className="print-filters">
//                 <span>From Date: {dateConversion(entryDateFrom)}</span>
//                 <span>To Date: {dateConversion(entryDateTo)}</span>
//                 <span>
//                   Depot: {selectedDepot === 'all' ? 'All Depots' : getDepotName(selectedDepot)}
//                 </span>
//               </Box>
//             </Box>

//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'flex-end',
//                 alignItems: 'center',
//                 padding: '10px',
//               }}
//               className="no-print"
//             >
//               <Button
//                 variant="outlined"
//                 startIcon={<Print />}
//                 onClick={handlePrint}
//                 disabled={displayData.length === 0}
//               >
//                 Print
//               </Button>
//             </Box>
//             <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Sr No</StyledTableCell>
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Empty Challan No</StyledTableCell>
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Empty Challan Date</StyledTableCell>
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>To Depot/Customer</StyledTableCell>
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Driver Name</StyledTableCell>
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Vehicle No</StyledTableCell>
//                     {/* <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Unregistered Driver</StyledTableCell> */}
//                     {/* <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Unregistered Vehicle</StyledTableCell> */}
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>No of Cyl</StyledTableCell>
//                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>From Depot</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                <TableBody sx={{ backgroundColor: { xs: '#fff', print: 'transparent' } }}>
//   {loading ? (
//     <StyledTableRow>
//       <StyledTableCell colSpan={10} align="center">
//         <Typography>Loading data...</Typography>
//       </StyledTableCell>
//     </StyledTableRow>
//   ) : displayData.length === 0 ? (
//     <StyledTableRow>
//       <StyledTableCell colSpan={10} align="center">
//         <Typography>No data found</Typography>
//       </StyledTableCell>
//     </StyledTableRow>
//   ) : (
//     sortedRows
//       .slice(
//         controller.page * controller.rowsPerPage,
//         (controller.page + 1) * controller.rowsPerPage
//       )
//       .map((row, index) => (
//         <StyledTableRow key={index}>
//           <StyledTableCell align="center">
//             {controller.page * controller.rowsPerPage + index + 1}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>{row.entry_no}</StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.entry_date)}</StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>
//             {row.to_depot_name || row.to_customer_name || 'N/A'}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>{row.driver_name || 'N/A'}</StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>{row.vehicle_no || 'N/A'}</StyledTableCell>
//           {/* <StyledTableCell className={styles.inspection_cell}>{row.unregistered_driver || 'N/A'}</StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>{row.unregistered_vehicle || 'N/A'}</StyledTableCell> */}
//           <StyledTableCell
//             sx={{ color: 'blue', cursor: 'pointer' }}
//             align="left"
//             className={styles.inspection_cell}
//             onClick={() => handleDetails(row.table_details)}
//           >
//             {JSON.parse(row.table_details)?.length || 0}
//           </StyledTableCell>
//           <StyledTableCell className={styles.inspection_cell}>{row.from_depot_name || 'N/A'}</StyledTableCell>
//         </StyledTableRow>
//       ))
//   )}
// </TableBody>

//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[10, 25, 100]}
//               component="div"
//               count={effectiveTotalCount}
//               rowsPerPage={controller.rowsPerPage}
//               page={controller.page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               className="no-print"
//             />
//           </Paper>
//         </Grid>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={() => setSuccessMessage('')}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//           className="no-print"
//         />

//         <BootstrapDialog
//           PaperProps={{
//             sx: {
//               minWidth: '90%',
//               maxHeight: '90%',
//             },
//           }}
//           onClose={handleClose}
//           open={openDetail}
//           className="no-print"
//         >
//           <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
//             Details
//           </BootstrapDialogTitle>
//           <DialogContent dividers>
//             <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table`}>
//               <Table size="small" stickyHeader className="printable-table">
//                 <TableHead className={styles.table_head_container}>
//                   <StyledTableRow>
//                     <StyledTableCell align="center">Sr No</StyledTableCell>
//                     <StyledTableCell align="left">Cylinder No</StyledTableCell>
//                     <StyledTableCell align="left">Tag No</StyledTableCell>
//                     <StyledTableCell align="left">Owner</StyledTableCell>
//                     <StyledTableCell align="left">Status</StyledTableCell>
//                     <StyledTableCell align="left">Remarks</StyledTableCell>
//                   </StyledTableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: { xs: '#fff', print: 'transparent' } }}>
//                   {info.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell align="center">{index + 1}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.cyl_no || 'N/A'}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.tag_no || 'N/A'}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.owner || 'N/A'}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.status || 'N/A'}</StyledTableCell>
//                       <StyledTableCell className={styles.inspection_cell}>{row.remark || 'N/A'}</StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </BootstrapDialog>
//       </Box>
//     </Box>
//   );
// };

// export default EmptyChallanReports;


import React, { useEffect, useState, useCallback } from 'react';
import {
  Box,
  Button,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  DialogContent,
  MenuItem,
  Dialog,
  IconButton,
} from '@mui/material';
import {
  Breadcrumb,
  CTSRinput,
  StyledTableCell,
  StyledTableRow,
} from '../../reusableComponent/Reusables';
import { useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { Print } from '@mui/icons-material';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import empty_delivery_challan from '../../../services/empty_delivery_challan';
import depotMasterService from '../../../services/masters/depotMaster.Service';
import CustomPagination from '../../reusableComponent/CustomPagination';
import { useSelector } from 'react-redux';

const printStyles = `
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .printable-table {
      width: 100% !important;
      border-collapse: collapse !important;
      overflow: visible !important;
    }
    .printable-table thead { display: table-header-group; }
    .printable-table tbody { display: table-row-group; }
    .MuiPaper-root, .MuiTableContainer-root {
      overflow: visible !important;
      max-height: none !important;
      box-shadow: none !important;
    }
    .no-print { display: none !important; }
    .print-header-info { display: block !important; margin-bottom: 10px; }
  }
  .print-header-info { display: none; }
`;

const EmptyChallanReports = () => {
  const location = useLocation();
  const editData = location.state || null;

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const depot_id = userInfo.depot_id;
  const plant_id = userInfo.plant_id;

  const defaultRowsPerPage = useSelector(state => state.delivery_challan.rows_per_page || 15);

  const [successMessage, setSuccessMessage] = useState('');
  const [displayData, setDisplayData] = useState([]);
  const [depot, setDepot] = useState([]);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState([]);
  const [openDetail, setDetail] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const {
    control,
    watch,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      entry_date_from: editData?.entry_date ?   dayjs(editData.entry_date).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD"),        // ← today
  entry_date_to: dayjs().format("YYYY-MM-DD"),
     
      depot: '',
    },
  });

  const entryDateFrom = watch('entry_date_from');
  const entryDateTo = watch('entry_date_to');
  const selectedDepot = watch('depot');

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const effectiveTotalCount = totalCount > 0 ? totalCount : displayData.length;

  // ── Effect 1: Depot list + print styles ──────────────────────────────────
  useEffect(() => {
    async function fetchDepotData() {
      try {
        setLoading(true);
        const depotData = await depotMasterService.getDepotList({
          page: 0,
          size: 999,
          searchKey: '',
        });
        setDepot(depotData || []);
      } catch (error) {
        console.error('Error fetching depot data:', error);
        setSuccessMessage('Error fetching depot data');
        setDepot([]);
      } finally {
        setLoading(false);
      }
    }
    fetchDepotData();

    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  // ── Effect 2: Reset page when filters change ─────────────────────────────
  useEffect(() => {
    setController(prev => ({ ...prev, page: 0 }));
  }, [entryDateFrom, entryDateTo, selectedDepot]);

  // ── Effect 3: Fetch data ──────────────────────────────────────────────────
  const handleShow = useCallback(async (formData) => {
    const { entry_date_from, entry_date_to, depot: depotVal } = formData;

    if (!entry_date_from) { setError('entry_date_from', { message: 'From Date is required' }); return; }
    if (!entry_date_to) { setError('entry_date_to', { message: 'To Date is required' }); return; }
    if (!depotVal) { setError('depot', { message: 'Depot is required' }); return; }
    if (dayjs(entry_date_to).isBefore(dayjs(entry_date_from))) {
      setError('entry_date_to', { message: 'To Date cannot be before From Date' }); return;
    }

    try {
      setLoading(true);
      setDisplayData([]);

      const filterParams = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: '',
        fromDate: entry_date_from,
        toDate: entry_date_to,
        from_depot_name: depotVal === 'all' ? '' : depotVal,
      };

      const response = await empty_delivery_challan.getEmptyChallanReport(filterParams);
      let fetchedData = response?.data || response || [];
      const total = response?.total_count ?? response?.totalCount ?? response?.count ?? fetchedData.length;

      if (depotVal !== 'all') {
        fetchedData = fetchedData.filter(row => row.from_depot_name === depotVal);
      }

      setDisplayData(fetchedData);
      setTotalCount(total);
    } catch (error) {
      console.error('Error fetching data:', error);
      setSuccessMessage(error.message || 'Error fetching data');
      setDisplayData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, [setError, controller.page, controller.rowsPerPage]);

  useEffect(() => {
    if (entryDateFrom && entryDateTo && selectedDepot &&
      !errors.entry_date_from && !errors.entry_date_to && !errors.depot) {
      handleShow({
        entry_date_from: entryDateFrom,
        entry_date_to: entryDateTo,
        depot: selectedDepot,
      });
    }
  }, [entryDateFrom, entryDateTo, selectedDepot, controller.page, controller.rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController(prev => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  const handlePrint = () => { window.print(); };

  // ── No of Cyl click → open detail dialog ─────────────────────────────────
  const handleDetails = (row) => {
    setSelectedRow(row);
    try { setInfo(JSON.parse(row.table_details || '[]')); } catch { setInfo([]); }
    setDetail(true);
  };

  const handleClose = () => { setDetail(false); setSelectedRow(null); setInfo([]); };

  const dateConversion = (date) => {
    if (!date) return '';
    const today = new Date(date);
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const getDepotName = (depot_name) => {
    const depotData = depot.find((d) => d.depot_name === depot_name);
    return depotData?.depot_name || depot_name || 'Unknown';
  };

  const getSelectedDepotName = () => {
    if (selectedDepot === 'all') return 'All Depots';
    return getDepotName(selectedDepot);
  };

  const cylinderHeaders = [
    'Sr No', 'Cylinder No', 'Tag No', 'Owner', 'Status', 'Remarks',
  ];

  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: 'Empty Challan Report' }]} />
        <Typography className={styles.header_txt}>EMPTY CHALLAN SUMMARY</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          component="form"
          sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: '12px', mb: 2, width: '100%' }}
        >
          {/* From Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '300px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              From Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller
              name="entry_date_from"
              control={control}
              render={({ field }) => (
                <CTSRinput
                  size="small" fullWidth type="date" {...field}
                  error={!!errors.entry_date_from}
                  helperText={errors.entry_date_from?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                />
              )}
            />
          </Box>

          {/* To Date */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 140px', minWidth: '150px', maxWidth: { xs: '100%', sm: '300px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              To Date <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller
              name="entry_date_to"
              control={control}
              render={({ field }) => (
                <CTSRinput
                  size="small" fullWidth type="date" {...field}
                  error={!!errors.entry_date_to}
                  helperText={errors.entry_date_to?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                />
              )}
            />
          </Box>

          {/* Depot */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '2 1 180px', minWidth: '150px', maxWidth: { xs: '100%', sm: '300px' } }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: '4px', whiteSpace: 'nowrap' }}>
              Depot <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Controller
              name="depot"
              control={control}
              rules={{ required: 'Depot is required' }}
              render={({ field }) => (
                <CTSRinput
                  select size="small" fullWidth {...field}
                  error={!!errors.depot}
                  helperText={errors.depot?.message}
                  InputProps={{ className: styles.CTSinput_Box }}
                >
                  <MenuItem value="">Select Depot</MenuItem>
                  <MenuItem value="all">All Depots</MenuItem>
                  {depot.map((depotItem) => (
                    <MenuItem key={depotItem.depot_id} value={depotItem.depot_name}>
                      {depotItem.depot_name}
                    </MenuItem>
                  ))}
                </CTSRinput>
              )}
            />
          </Box>

          {/* Print Button */}
          <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: '0 0 auto', ml: { xs: 'auto', sm: 0 } }}>
            <Button
              variant="outlined" startIcon={<Print />} onClick={handlePrint}
              disabled={displayData.length === 0} size="small"
              sx={{ whiteSpace: 'nowrap', height: '30px' }}
            >
              Print
            </Button>
          </Box>
        </Box>

        {/* ── Main Table ── */}
        <Grid item xs={12}>
          <Paper sx={{ width: '100%' }}>
            <div className="printable-area">
              <div className="print-header-info" style={{ marginBottom: '20px' }}>
                <Typography variant="h4" align="left" sx={{ fontWeight: 'bold' }}>Empty Challan Report</Typography>
                <Typography variant="body1" align="left" sx={{ marginTop: 1 }}>
                  From: {dateConversion(entryDateFrom)} &nbsp;|&nbsp; To: {dateConversion(entryDateTo)} &nbsp;|&nbsp; Depot: {getSelectedDepotName()}
                </Typography>
              </div>

              <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead>
                    <StyledTableRow>
                      {['Sr No', 'Empty Challan No', 'Empty Challan Date', 'To Depot/Customer',
                        'Driver Name', 'Vehicle No', 'No of Cyl', 'From Depot'].map((h) => (
                        <StyledTableCell key={h} sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
                          {h}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#fff' }}>
                    {loading ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={8} align="center">
                          <Typography>Loading data...</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : displayData.length === 0 ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={8} align="center">
                          <Typography>No data found</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      displayData.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="left">
                            {controller.page * controller.rowsPerPage + index + 1}
                          </StyledTableCell>
                          {/* Empty Challan No — clickable */}
                          <StyledTableCell onClick={() => handleDetails(row)}>
                            <Typography sx={{
                              fontSize: '12px', fontWeight: 'bold', cursor: 'pointer',
                              color: '#1976d2 !important', textDecoration: 'underline',
                            }}>
                              {row.entry_no}
                            </Typography>
                          </StyledTableCell>

                          <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.entry_date)}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>
                            {row.to_depot_name || row.to_customer_name || 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.driver_name || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.vehicle_no || 'N/A'}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell} align="left">
                            {JSON.parse(row.table_details)?.length || 0}
                          </StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.from_depot_name || 'N/A'}</StyledTableCell>
                        </StyledTableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <CustomPagination
              page={controller.page}
              rowsPerPage={controller.rowsPerPage}
              totalCount={effectiveTotalCount || 0}
              onPageChange={(newPage) => handleChangePage(null, newPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="no-print"
            />
          </Paper>
        </Grid>

        {/* ── Snackbar ── */}
        <ReusableSnackbar
          open={!!successMessage}
          onClose={() => setSuccessMessage('')}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
          className="no-print"
        />

        {/* ── Detail Dialog ── */}
        <Dialog
          open={openDetail}
          onClose={handleClose}
          maxWidth={false}
          className="no-print"
          sx={{
            '& .MuiDialog-paper': {
              margin: 'auto', width: '92vw', maxHeight: '85vh',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              overflow: 'hidden', fontFamily: "'Inter', Arial, sans-serif",
            },
          }}
        >
          {/* Header */}
          <Box sx={{ background: '#1C3A5E', padding: '14px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#fff', letterSpacing: '0.5px', fontFamily: "'Inter', Arial, sans-serif" }}>
              EMPTY CHALLAN DETAILS
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: '#fff', p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: '20px 24px', background: '#F4F7FB', overflowY: 'auto' }}>

            {/* ── Entry Info Card ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden', mb: 2.5 }}>
              <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  📋 Challan Information
                </Typography>
              </Box>
              <Grid container>
                {[
                  { label: 'Challan No',          value: selectedRow?.entry_no,                                         border: true,  bottom: true },
                  { label: 'Challan Date',         value: dateConversion(selectedRow?.entry_date),                       border: true,  bottom: true },
                  { label: 'To Depot/Customer',    value: selectedRow?.to_depot_name || selectedRow?.to_customer_name,   border: true,  bottom: true },
                  { label: 'From Depot',           value: selectedRow?.from_depot_name,                                  border: false, bottom: true },
                  { label: 'Driver Name',          value: selectedRow?.driver_name,                                      border: true,  bottom: false },
                  { label: 'Vehicle No',           value: selectedRow?.vehicle_no,                                       border: false, bottom: false },
                ].map(({ label, value, border, bottom }) => (
                  <Grid
                    key={label} item xs={12} sm={6} md={3}
                    sx={{
                      borderRight: border ? '1px solid #EDF2F7' : 'none',
                      borderBottom: bottom ? '1px solid #EDF2F7' : 'none',
                      padding: '12px 16px',
                    }}
                  >
                    <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.6px', mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      {label}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: label === 'Challan No' ? 700 : 600, color: label === 'Challan No' ? '#1C3A5E' : '#2D3748', fontFamily: "'Inter', Arial, sans-serif" }}>
                      {value || 'N/A'}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: '#fff', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              {/* <Box sx={{ background: '#2A4F7A', padding: '9px 18px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#fff', letterSpacing: '0.4px', fontFamily: "'Inter', Arial, sans-serif" }}>
                  🛢️ Cylinder Details
                </Typography>
              </Box> */}
              <TableContainer sx={{ maxHeight: '350px' }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {cylinderHeaders.map((header) => (
                        <StyledTableCell
                          key={header} align="center"
                          sx={{
                            backgroundColor: '#1C3A5E !important',
                            color: '#fff !important',
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700, fontSize: '11px',
                            padding: '10px 8px', whiteSpace: 'nowrap',
                            borderRight: '1px solid rgba(255,255,255,0.1)',
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {info.length > 0 ? (
                      info.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{ backgroundColor: index % 2 === 0 ? '#fff' : '#F8FAFC', '&:hover': { backgroundColor: '#EBF4FF' } }}
                        >
                          {[
                            index + 1,
                            row.cyl_no   || 'N/A',
                            row.tag_no   || 'N/A',
                            row.owner    || 'N/A',
                            row.status   || 'N/A',
                            row.remark   || 'N/A',
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci} align="center"
                              sx={{ fontSize: '11px', fontFamily: "'Inter', Arial, sans-serif", color: '#2D3748', padding: '8px 6px', borderBottom: '1px solid #EDF2F7', whiteSpace: 'nowrap' }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={cylinderHeaders.length} align="center"
                          sx={{ py: 5, fontSize: '13px', color: '#A0AEC0', fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          {/* Footer */}
          <Box sx={{ padding: '12px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={handleClose}
              sx={{
                background: '#E53E3E', color: '#fff', fontSize: '13px', fontWeight: 600,
                textTransform: 'none', padding: '7px 20px', borderRadius: '8px',
                fontFamily: "'Inter', Arial, sans-serif",
                '&:hover': { background: '#971f16' },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

      </Box>
    </Box>
  );
};

export default EmptyChallanReports;